export default (state = [], action) => {
    switch (action.type) {
        case "SEARCH_BY_NAME_MULTIRESULT_DATA":
            return action.payload;
        default:
            return state;
    }
};